// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IAutoInvestmentRuleDto } from './IAutoInvestmentRuleDto';
import {
    IAutoInvestmentRuleDtoFromJSON,
    IAutoInvestmentRuleDtoFromJSONTyped,
    IAutoInvestmentRuleDtoToJSON,
    IAutoInvestmentRuleDtoToJSONTyped,
} from './IAutoInvestmentRuleDto';

/**
 * 
 * @export
 * @interface IAutoInvestmentSchedulerUpdateDto
 */
export interface IAutoInvestmentSchedulerUpdateDto {
    /**
     * 
     * @type {number}
     * @memberof IAutoInvestmentSchedulerUpdateDto
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof IAutoInvestmentSchedulerUpdateDto
     */
    amount_to_keep: number;
    /**
     * 
     * @type {Array<IAutoInvestmentRuleDto>}
     * @memberof IAutoInvestmentSchedulerUpdateDto
     */
    auto_investment_rules?: Array<IAutoInvestmentRuleDto>;
    /**
     * 
     * @type {string}
     * @memberof IAutoInvestmentSchedulerUpdateDto
     */
    status: IAutoInvestmentSchedulerUpdateDtoStatusEnum;
}

/**
* @export
* @enum {string}
*/
export enum IAutoInvestmentSchedulerUpdateDtoStatusEnum {
    ACTIVE = 'ACTIVE',
    PAUSED = 'PAUSED'
}


/**
 * Check if a given object implements the IAutoInvestmentSchedulerUpdateDto interface.
 */
export function instanceOfIAutoInvestmentSchedulerUpdateDto(value: object): value is IAutoInvestmentSchedulerUpdateDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('amount_to_keep' in value) || value['amount_to_keep'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function IAutoInvestmentSchedulerUpdateDtoFromJSON(json: any): IAutoInvestmentSchedulerUpdateDto {
    return IAutoInvestmentSchedulerUpdateDtoFromJSONTyped(json, false);
}

export function IAutoInvestmentSchedulerUpdateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAutoInvestmentSchedulerUpdateDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'amount_to_keep': json['amount_to_keep'],
        'auto_investment_rules': json['auto_investment_rules'] == null ? undefined : ((json['auto_investment_rules'] as Array<any>).map(IAutoInvestmentRuleDtoFromJSON)),
        'status': json['status'],
    };
}

export function IAutoInvestmentSchedulerUpdateDtoToJSON(json: any): IAutoInvestmentSchedulerUpdateDto {
    return IAutoInvestmentSchedulerUpdateDtoToJSONTyped(json, false);
}

export function IAutoInvestmentSchedulerUpdateDtoToJSONTyped(value?: IAutoInvestmentSchedulerUpdateDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'amount_to_keep': value['amount_to_keep'],
        'auto_investment_rules': value['auto_investment_rules'] == null ? undefined : ((value['auto_investment_rules'] as Array<any>).map(IAutoInvestmentRuleDtoToJSON)),
        'status': value['status'],
    };
}

